module.exports = __webpack_public_path__ + "static/11-60c1d0650146263a839f655cf66e4a58.jpeg";